import React from 'react';
import './Signal.css';

/**
 * F10.3 — 4-bar signal-strength meter.
 *
 * Mirrors the inline `Signal` component from
 * `design/sharing-screens.jsx` lines 20-26: four vertically baseline-aligned
 * bars of increasing height (6/9/12/14 px), filled left-to-right based on
 * the active bar count.
 *
 * Props:
 *  - `bars`  — `1 | 2 | 3 | 4 | null`. `null` renders all bars in the inactive
 *              colour (= "no peer connection yet").
 *  - `color` — fill colour for active bars. Defaults to `var(--lan)` with a
 *              literal fallback so the bars still light up before the LAN
 *              token migrates into `src/styles`.
 *
 * The component is purely presentational and CSS-driven — no transitions are
 * applied on the bar fills, so `prefers-reduced-motion` is honored by
 * construction.
 */
const BAR_HEIGHTS = [6, 9, 12, 14];
const INACTIVE = 'rgba(255,255,255,.18)';

const Signal = ({ bars = 3, color = 'var(--lan, #3fdc8a)' }) => {
  const active = bars == null ? 0 : bars;
  const label =
    bars == null
      ? 'Signal strength: no connection'
      : `Signal strength: ${bars} of 4`;

  return (
    <span className="signal" role="img" aria-label={label}>
      {BAR_HEIGHTS.map((h, i) => (
        <i
          key={i}
          style={{
            height: h,
            background: i < active ? color : INACTIVE,
          }}
        />
      ))}
    </span>
  );
};

export default Signal;
